var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgArrowBottomRight = function SvgArrowBottomRight(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46462 17.9497C7.91234 17.9497 7.46462 17.502 7.46462 16.9497C7.46462 16.3974 7.91234 15.9497 8.46462 15.9497L14.5357 15.9497L6.3433 7.75731C5.95278 7.36679 5.95278 6.73362 6.3433 6.3431C6.73383 5.95258 7.36699 5.95257 7.75752 6.3431L15.9499 14.5355V8.46442C15.9499 7.91214 16.3976 7.46442 16.9499 7.46442C17.5022 7.46442 17.9499 7.91213 17.9499 8.46442V16.9497C17.9499 17.502 17.5022 17.9497 16.9499 17.9497L8.46462 17.9497Z",
    fill: "black"
  })));
};
export { SvgArrowBottomRight as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-bottom-right.11e317be.svg";